import { useEffect, useRef, useState } from "react";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "./FindYourState.css"
import { useNavigate } from "react-router-dom";
export default function FindYourState() {
  const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [activeState, setActiveState] = useState(null);
    const [show, setShow] = useState(false);
    const sectionRef = useRef(null);
    
    useEffect(() => {
    
      const observer = new IntersectionObserver(
        ([entry]) => {
          if(entry.isIntersecting){
            setShow(true);
          }
        },
        {
          threshold:0.2
        }
      );
    
      if(sectionRef.current){
        observer.observe(sectionRef.current);
      }
    
      return () => {
        if(sectionRef.current){
          observer.unobserve(sectionRef.current);
        }
      };
    
    }, []);
  const states = [
  {
  id: 1,
  title: "I Need Clarity",
  description:
    "Mental fog · Cognitive overload · Can't concentrate",
  tags: ["Mental fog", "Cognitive overload", "Can't concentrate"],
  why:
    "Peppermint and eucalyptus directly activate your alertness pathways — helping refresh the mind, clear mental fog and support focused energy. Geranium brings balance, while lavender softens the nervous system so clarity feels calm, not forced.",
  cta: "Explore Clarity Candles",
  image: "/state/state1.jpeg",
  recommended: [
    {
      name: "Verdant Grace",
      slug: "verdant-grace",
      category: "Wellness",
      price: "₹1,150",
      desc: "Peppermint, eucalyptus, geranium, lavender. The primary clarity candle — a crisp botanical reset for the overloaded mind.",
      experience: "Fresh · Clear · Focused",
    },
    {
      name: "Veyra",
      slug: "veyra",
      category: "Wellness",
      price: "₹1,150",
      desc: "Neroli, lemon, bergamot, ylang ylang. For when clarity needs a lift of optimism alongside the focus.",
      experience: "Light · Uplifting · Energising",
    },
  ],
},
  {
    id: 2,
    title: "I Need a Mood Lift",
    description:
      "Emotionally flat, uninspired, low mood, lacking motivation.",
    image: "/state/state2.jpeg",
      tags: ["Emotionally flat", "uninspired", "Low mood", "going through the motions"],
  why:
    "Citrus oils — neroli, bergamot, jasmine — have documented effects on serotonin pathways, the neurotransmitter most directly linked to mood. They don't overstimulate; they gently shift your emotional baseline upward. Jasmine in particular has been studied for its ability to generate feelings of warmth and optimism. You feel lighter before you understand why.",
  cta: "Explore mood Candles",
  recommended: [
    {
      name: "Veyra",
        slug: "veyra",
      category: "Wellness",
      price: "₹1,150",
      desc: "Neroli, lemon, bergamot, ylang ylang. For when clarity needs a lift of optimism alongside the focus.",
      experience: "bright · joyful · Energising",
    },
    {
      name: "Aurelia Bloom",
      slug: "aurelia-bloom",
      category: "Signature",
      price: "₹599",
      desc: "Jasmine, saffron, sandalwood. Radiant and golden — for emotional uplift with a luxurious, warm quality.",
      experience: "Radiant · Warm · Luminous",
    },

  ],
  },
  {
    id: 3,
    title: "I Need Grounding",
    description:
      "Scattered, unsettled, low-grade anxiety, disconnected.",
    image: "/state/state3.jpeg",
     tags: ["Scattered", "Emotionally untethered", "Low-grade anxiety", "overstimulated"],
  why:
    " Vetiver, frankincense, and tulsi (holy basil) work on your parasympathetic nervous system — the part of your body responsible for coming down from stress. Vetiver has been clinically studied for its sedative effects on the central nervous system. When these oils reach your bloodstream through inhalation, cortisol drops and your body stops trying to flee. You feel your feet on the floor again.",
  cta: "Explore Grounding Candles",
  recommended: [
    {
      name: "Viridian spirit",
      slug: "viridian-spirit",
      category: "Wellness",
      price: "₹1,150",
      desc: "Tulsi, vetiver, cypress, frankincense, petrichor. Deep, earthy, immediate. The most grounding candle in the collection.",
      experience: "Rooted · Present · Stable",
    },
    {
      name: "Survarna Vrikshha",
      slug: "survarna-vrisksha",
      category: "Signature",
      price: "₹599",
      desc: "Sandalwood, frankincense. A more meditative, sacred grounding — for when steadiness needs to feel reverential.",
      experience: "Sacred · Still · Reverent",
    },

  ],
  },
  {
    id: 4,
    title: "I Need Deep Rest",
    description:
      "Restless, can't switch off, mentally active at night.",
    image: "/state/state4.jpeg",
    tags: ["Can't Switch Off", "Restless sleep", "Overstimulated", "mentally active at night"],
    why:
      " Lavender is the most research-backed essential oil for sleep — multiple clinical trials show it reduces time to fall asleep and improves sleep quality. Clary sage goes further: it lowers cortisol levels by up to 36% in documented studies. Vetiver's deep, earthy weight acts as a sedative on the central nervous system. Vanilla creates the neurological signature of warmth and safety. This is not a candle that smells relaxing. It genuinely prepares your body for sleep.",
    cta: "Explore Rest Candles",
    recommended: [
      {
        name: "moonveil",
        slug: "moonveil",
        category: "Wellness",
        price: "₹1,150",
        desc: "Lavender, clary sage, vetiver, vanilla, tonka. The primary sleep candle. Light 30 minutes before bed and let it do its work.",
        experience: "Soft · Quiet · Restorative",
      },
      {
        name: "Serenelle",
        slug: "Serenelle",
        category: "wellness",
        price: "₹1,150",
        desc: "Jasmine sambac, rose otto, sandalwood, vanilla. For rest that also needs emotional softness — when the heart needs quieting alongside the mind.",
        experience: "Nurturing · Warm · Reassuring",
      },

    ],
  },
  {
    id: 5,
    title: "I Need Comfort",
    description:
      "Emotionally tender, lonely, grieving, needing self-care.",
    image: "/state/state5.jpeg",
    tags: ["Emotionally tender", "lonely", "grieving or processing", "needing self-care"],
    why:
      "Rose otto is one of the most emotionally complex essential oils in scientific literature — research links it to increased oxytocin (the bonding hormone) and measurable reductions in feelings of grief and loneliness. Jasmine sambac creates warmth and a sense of gentle closeness. Sandalwood and vanilla together produce the neurological signature of safety — the same emotional register as being held. This is a candle that cares for you.",
    cta: "Explore Comfort Candles",
    recommended: [
      {
        name: "Serenelle",
         slug: "Serenelle",
        category: "Wellness",
        price: "₹1,150",
        desc: "Jasmine sambac, rose otto, sandalwood, vanilla. The strongest emotional comfort candle in the collection. For when everything just needs to feel softer.",
        experience: "Held · Soft · Quietly Reassuring",
      },
       {
        name: "moonveil",
         slug: "moonveil",
        category: "Wellness",
        price: "₹1,150",
        desc: "Lavender, clary sage, vetiver, vanilla, tonka. The primary sleep candle. Light 30 minutes before bed and let it do its work.",
        experience: "  Quiet · Enveloping · safe",
      },

    ],
  },
  {
    id: 6,
    title: "I Need Inner Peace",
    description:
      "Emotionally noisy, reactive, seeking stillness and calm.",
    image: "/state/state6.jpeg",
    tags: [ "Emotionally loud" ," reactive", "seeking stillness", "pulled in all direction."],
    why:
      "Frankincense has been used in contemplative traditions for centuries — and research now confirms why: it activates ion channels in the brain that measurably alleviate anxiety. Sandalwood slows neural activity. Nagchampa and lotus create the specific sensory atmosphere your nervous system associates with sacred space — not through belief, but through years of neurological conditioning. Stillness becomes a physical state, not just an aspiration.",
    cta: "Explore Peace Candles",
    recommended: [
      {
        name: "Sacred Serenity",
         slug: "sacred-serenity",
        category: "signature",
        price: "₹599",
        desc: "Nagchampa, divine lotus. Temple-air stillness — the most direct route to emotional quiet in the range.",
        experience: "Centred · Sacred · Still",
      },
     {
         name: "Suvarna Vrikshha",
         slug: "survarna-vrisksha",
          category: "Signature",
          price: "₹599",
          desc: "Sandalwood, frankincense. A more meditative, sacred grounding — for when steadiness needs to feel reverential.",
          experience: "deep · meditative · Reverent",
      },

    ],
  },
  {
    id: 7,
    title: "I'm Seeking Reflection",
    description:
      "Introspective, journaling, processing emotions, seeking perspective.",
    image: "/state/state7.jpeg",
     tags: [ "Introspective" ," journaling", "processing emotions", "seeking perspective"],
    why:
      "Deep reflection requires your prefrontal cortex — the seat of meaning-making — to be calm and accessible. Grounding oils like vetiver, tulsi, and frankincense reduce amygdala reactivity, quieting the emotional noise that interferes with clear self-reflection. Your thoughts become less reactive, more contemplative. What felt tangled begins to clarify.",
    cta: "Explore reflection Candles",
    recommended: [
       {
      name: "Viridian spirit",
      slug: "viridian-spirit",
      category: "Wellness",
      price: "₹1,150",
      desc: "Tulsi, vetiver, cypress, frankincense, petrichor. Deep, earthy, immediate. The most grounding candle in the collection.",
      experience: "Rooted · Present · Stable",
    },
     {
         name: "Intuition & wisdom",
         slug: "intuition-wisdom-candle",
          category: "ritual",
          price: "₹49",
          desc: "Purple herb-rolled ritual candle. For inward listening, card pulls, spiritual reflection, and moments of inner knowing.",
          experience: "wise · reflective · spiritual",
      },

    ],
  },
  {
    id: 8,
    title: "I Want to Set an Intention",
    description:
      "New beginnings, healing, protection, creativity, manifestation.",
    image: "/state/state8.jpeg",
    tags: [ "setting intentions" ," new chapter", "self love ritual", "energectic protection" ,"creative ritual"],
    why:
      "Our herb-rolled ritual candles are built on a different philosophy — colour psychology, botanical symbolism, and the act of lighting a flame with declared purpose. Research on intention-setting shows that naming what you want before a symbolic act measurably increases follow-through and emotional clarity. What you say before you light matters. These candles are built for that moment.",
    cta: "Explore the ritual collections",
    recommended: [
       {
      name: "protection",
       slug: "protection-candle",
      category: "Ritual",
      price: "₹49",
      desc: "Black herb-rolled candle. Guard your energy, set boundaries, cleanse the mood of a space. Light when you need to return to your centre.",
      experience: "Safe · Grounded · Protected",
    },
     {
         name: "Confidence & joy",
          slug: "confidence-joy-candle",
          category: "ritual",
          price: "₹49",
          desc: "Yellow herb-rolled candle. Before a new beginning, a presentation, or any moment where your inner light needs encouragement.",
          experience: "Bright · Courageous · Open",
      },

    ],
  },
   {
    id: 9,
    title: "I Want to elevate my space",
    description:
      "Hosting, celebrating, creating ambience, luxury, indulgence.",
    image: "/state/state9.jpeg",
     tags: [ "Hosting" ,"creating ambience", "celebrating", "indulging in luxury"],
    why:
      "Scent is processed socially — shared fragrance creates shared emotional states. Jasmine, saffron, neroli, and bergamot produce the specific olfactory signature that the brain associates with warmth, refinement, and welcome. The right candle doesn't just make your home smell beautiful; it shifts how every person in the room feels about being there.",
    cta: "Explore ambience candles",
    recommended: [
       {
      name: "Aurelia Bloom",
      slug: "aurelia-bloom",
      category: "Signature",
      price: "₹599",
      desc: "Jasmine, saffron, sandalwood. Radiant and golden — for emotional uplift with a luxurious, warm quality.",
      experience: "elegant · Warm · Luminous",
    },
     {
         name: "Citrus ember",
         slug: "citrus-ember",
          category: "lifestyle",
          price: "₹699",
          desc: "Orange, cinnamon, vanilla, caramel. Vibrant and festive — for gatherings that call for warmth and playful energy.",
          experience: "vibrant · festive · inviting",
      },

    ],
  },
];

  return (
    <>
    <Header/>
      <section
        style={{
          margin: "0 auto",
          padding: isMobile ? "50px 20px 80px" : "60px 40px 80px",
          color: "#4c144e",
          marginTop:isMobile ? "60px" : "100px",
        }}
      >
        {/* TOP CONTENT */}

        <div
          style={{
            textAlign: "center",
            margin: isMobile ? "0" : "30px 0",
          }}
        >
          {/* <p
            style={{
              color: "##17130f",
              marginBottom: "20px",
              fontSize: "18px",
            }}
          >
            ✦
          </p> */}

          <h1
            style={{
              fontSize:  isMobile ? "20px" : "30px",
              fontWeight: 100,
              marginBottom: isMobile ? "20px" : "10px",
              textTransform:"capitalize"

            }}
          >
            Find Your State. Find Your{" "}
            <span
              style={{
                color: "#4c144e",
                fontStyle: "italic",
              }}
            >
              Flame.
            </span>
          </h1>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              color: "#17130f",
              fontSize: "15px",
              lineHeight: "1.8",
              textTransform:"none"
            }}
          >
            Scents have the power to shift how we feel. Choose the state
            you want to cultivate and discover the candles crafted to
            support it.
          </p>
        </div>

        {/* GRID */}

       <div className="features-band">
          {states.map((item) => (
             <div
              key={item.id}
              onClick={() => setActiveState(item)}
              style={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "5px",
                height: "450px",
                cursor: "pointer",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
          <div
  style={{
    position: "relative",
    width: "100%",
    height: "100%",
  }}
>
  <img
    src={item.image}
    alt={item.title}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
    }}
  />

  {/* Dark Overlay */}
  <div
    style={{
      position: "absolute",
      inset: 0,
      // background:
      //   "linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0.4), rgba(0,0,0,0.15))",
    }}
  />
</div>

              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,.92), rgba(0,0,0,.25))",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  top: "18px",
                  left: "18px",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  border: "1px solid rgba(255,255,255,.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                {item.id}
              </div>

              <div className="state-card-content">
                <h3 className="state-card-title">
                  {item.title}
                </h3>

                <p className="state-card-desc">
                  {item.description}
                </p>

                <button className="state-card-btn">
                   Recommended candles→
                </button>
              </div>
            </div>
          ))}
        </div>
<section className="features-band" ref={sectionRef}>
  <div
    className="feature-item"
    style={{
      opacity: show ? 1 : 0,
    }}
  >
    <div className="feature-icon">
      <img src='/icon/11.png' alt="Pure & Conscious" />
    </div>

    <h4>Pure & Conscious</h4>

    <p style={{ textTransform: "capitalize" }}>
      Made with clean ingredients, pure essential oils and natural waxes.
    </p>
  </div>

  <div
    className="feature-item"
    style={{
      opacity: show ? 1 : 0,
      transform: show ? "translateY(0)" : "translateY(70px)",
      transitionDelay: "0.3s",
    }}
  >
    <div className="feature-icon">
    <img src="/icon/6.png" alt="Crafted For Wellbeing" />
    </div>

    <h4>Crafted For Wellbeing</h4>

    <p style={{ textTransform: "capitalize" }}>
      Every blend is intentionally created to support your mind, body And rituals.
    </p>
  </div>

  <div
    className="feature-item no-border"
    style={{
      opacity: show ? 1 : 0,
      transform: show ? "translateY(0)" : "translateY(70px)",
      transitionDelay: "0.5s",
    }}
  >
    <div className="feature-icon">
      <img src='/icon/12.png' alt="Ritual In Every Flame" />
    </div>

    <h4>Ritual In Every Flame</h4>

    <p>
      More than a candle — a moment of return to yourself.
    </p>
  </div>
</section>
        {/* FEATURES */}

        <div
          style={{
            marginTop: isMobile ? "20px" : "50px",
            textAlign: "center",
            color: "#4c144e",
            fontSize: "14px",
            fontWeight:"100"
          }}
        >
          Scent Is Energy. Intention is everything.
        </div>
      </section>
{activeState && (
  <div className="state-modal-overlay">
    <div className="state-modal">
      <button
        className="state-modal-close"
        onClick={() => setActiveState(null)}
      >
        ×
      </button>

      <div className="state-modal-left">
        <span className="state-eyebrow">When you feel</span>

        <h2>{activeState.title}</h2>

        

        <div className="state-tags">
          {(activeState.tags || activeState.description.split(",")).map(
            (tag, index) => (
              <span key={index}>{tag}</span>
            )
          )}
        </div>

        <div className="why-box">
          <h4>Why it works</h4>
          <p>
            {activeState.why ||
              "This ritual candle is selected to support your current emotional state through intentional scent, atmosphere and quiet sensory grounding."}
          </p>
        </div>

        {/* <button
          className="state-explore-btn"
          onClick={() => {
            setActiveState(null);
            window.location.href = "/shop-all";
          }}
        >
          {activeState.cta || "Explore Candles"} <span></span>
        </button> */}
      </div>

      <div className="state-modal-right">
        <h4>Recommended for you</h4>

        {(activeState.recommended || [
          {
            name: "Verdant Grace",
            category: "Wellness",
            price: "₹1,150",
            desc: "A clean, uplifting blend created to support focus, calm and emotional clarity.",
            experience: "Fresh · Clear · Focused",
          },
          {
            name: "Veyra",
            category: "Wellness",
            price: "₹1,150",
            desc: "A bright botanical candle for a lighter, more refreshed state of mind.",
            experience: "Light · Uplifting · Energising",
          },
        ]).map((product, index) => (
          <div
  className="recommended-card"
  key={index}
  onClick={() => {
    if (product.slug) {
      setActiveState(null);
      navigate(`/product/${product.slug}`);
    }
  }}
  style={{ cursor: "pointer" }}
>
            <div className="recommended-top">
              <h3>{product.name}</h3>

              {/* <span>
                {product.category} · {product.price}
              </span> */}
            </div>

            <p>{product.desc}</p>

            <small>Experience: {product.experience}</small>
          </div>
        ))}
      </div>
    </div>
  </div>
)}
      <Footer />
    </>
  );
}